import React, { useState, useEffect } from 'react';
import { useStateValue } from "../StateProvider";
import { firestoreV9, collection, query, where, limit } from '../firebase';
import { getDocs } from 'firebase/firestore';


                    //userid gebraucht!! nur TEMPORÄR nicht gezeigt
function FBGetSongsFromDB({userid, anzahlSongsZufall, authReady}) {
    // packageOfSongsTorate IST BENÖTIGT
const [{dbTrackSelection, slideNrToShowToUser, songsRated}, dispatch] = useStateValue();


//war drin packageOfSongsTorate, 






  const [showSelection, setShowSelection] = useState(

   false

  );

  // Get visit count from localStorage and determine which songs to fetch
  // Only increment on new login (not page refresh) or after completing the full flow
  const [visitCount] = useState(() => {
    const storedCount = localStorage.getItem('songCarouselVisitCount');
    const sessionStartTime = sessionStorage.getItem('songCarouselSessionStart');
    const currentTime = Date.now();

    // Consider it a new session if:
    // 1. No session start time exists (first visit or after logout)
    // 2. More than 30 minutes have passed (session timeout)
    const isNewSession = !sessionStartTime || (currentTime - parseInt(sessionStartTime, 10)) > 30 * 60 * 1000;

    if (isNewSession) {
      // New session - increment visit count
      sessionStorage.setItem('songCarouselSessionStart', currentTime.toString());
      const currentVisit = storedCount ? parseInt(storedCount, 10) : 0;
      const newCount = (currentVisit % 3) + 1; // Cycle 1, 2, 3
      localStorage.setItem('songCarouselVisitCount', newCount.toString());
      return newCount;
    } else {
      // Existing session - use current count without incrementing
      const currentCount = storedCount ? parseInt(storedCount, 10) : 1;
      return currentCount;
    }
  });

const tracksToRateRef = collection(firestoreV9, dbTrackSelection);

  // State for direct queries (replacing react-firebase-hooks)
  const [selectionOfTracks, setSelectionOfTracks] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch songs using direct Firestore queries (bypassing react-firebase-hooks)
  useEffect(() => {
    const fetchSongs = async () => {
      try {
        // Filtered query - exclude current user's songs
        const filteredQueryRef = query(tracksToRateRef, where("fromspotifyuser", "!=", userid), limit(150));
        const filteredSnapshot = await getDocs(filteredQueryRef);
        const filteredSongs = filteredSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Shuffle songs immediately after fetching to randomize order on each login/reload
        const shuffledSongs = shuffleArray(filteredSongs);
        setSelectionOfTracks(shuffledSongs);

        setLoading(false);
      } catch (err) {
        console.error('❌ Error fetching songs:', err);
        setLoading(false);
      }
    };

    fetchSongs();
  }, [dbTrackSelection, userid, tracksToRateRef]);
    




  // Set showSelection to true after songs are fetched (even if empty)
  // Also dispatch empty array immediately if no songs found
  useEffect(() => {
    if (selectionOfTracks !== null && !loading) {
      setShowSelection(true);

      // If no songs available, immediately dispatch empty array to prevent loading state
      if (selectionOfTracks.length === 0) {
        dispatch({
          type: "SET_PACKAGEOFSONGSTORATE",
          packageOfSongsTorate: [],
        });
        dispatch({
          type: "SET_DBLESENJANEIN",
          dblesenerlauben: 0,
        });
      }
    }
  }, [selectionOfTracks, slideNrToShowToUser, anzahlSongsZufall, loading, dispatch]);





// nachpromise

// Helper function to remove duplicate track IDs (keep first occurrence)
const removeDuplicateTrackIds = (tracks) => {
  const seenTrackIds = new Set();
  return tracks.filter(track => {
    if (seenTrackIds.has(track.trackid)) {
      return false;
    }
    seenTrackIds.add(track.trackid);
    return true;
  });
};

// Helper function to filter out previously rated songs
const filterOutRatedSongs = (tracks, ratedSongs) => {
  return tracks.filter(track => {
    // Exclude track if it has been rated before
    if (ratedSongs && ratedSongs[track.trackid]) {
      console.log(`Filtering out previously rated song: ${track.trackid}`);
      return false;
    }
    return true;
  });
};

// Helper function to limit songs per Spotify User ID (max 2 songs per uploader)
const limitSongsPerSpotifyUser = (tracks) => {
  const songsPerUser = new Map();

  return tracks.filter(track => {
    const uploaderId = track.fromspotifyuser;
    const currentCount = songsPerUser.get(uploaderId) || 0;

    if (currentCount >= 2) {
      return false;
    }

    songsPerUser.set(uploaderId, currentCount + 1);
    return true;
  });
};

// Helper function to shuffle array using Fisher-Yates algorithm
// This ensures random order after each login and reload
const shuffleArray = (array) => {
  const shuffled = [...array]; // Create a copy to avoid mutating original
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};


// Helper function to get song range based on visit count
// Dynamically adjust based on available songs
const getSongRange = (visitCount, totalSongs) => {
  // If we have very few songs, just show all
  if (totalSongs <= 20) {
    return { start: 0, end: totalSongs };
  }

  // Calculate songs per visit to maximize usage (aim for ~1/3 of total per visit)
  const songsPerVisit = Math.ceil(totalSongs / 3);

  // If we have between 20 and 60 songs, adjust ranges dynamically
  if (totalSongs < 60) {
    const ranges = {
      1: { start: 0, end: Math.min(songsPerVisit, totalSongs) },
      2: { start: Math.min(songsPerVisit, totalSongs - songsPerVisit), end: Math.min(songsPerVisit * 2, totalSongs) },
      3: { start: Math.max(0, totalSongs - songsPerVisit), end: totalSongs }
    };
    return ranges[visitCount] || ranges[1];
  }

  // Optimal case: 60+ songs available - distribute evenly
  const ranges = {
    1: { start: 0, end: songsPerVisit },                    // First visit: first third
    2: { start: totalSongs - songsPerVisit, end: totalSongs },  // Second visit: last third
    3: { start: songsPerVisit, end: songsPerVisit * 2 }     // Third visit: middle third
  };
  return ranges[visitCount] || ranges[1]; // Default to first range
};

// Use effect to handle song dispatching when conditions are met
// This ensures dispatch happens even on mobile when state updates
useEffect(() => {
  // Only proceed if we have all necessary data
  if (!showSelection || selectionOfTracks === null || selectionOfTracks.length === 0) {
    return;
  }

  console.log(`🔄 Processing songs dispatch: showSelection=${showSelection}, slide=${slideNrToShowToUser}, anzahlSongsZufall=${anzahlSongsZufall}`);

  // Check if there's a currently playing song in localStorage
  let currentlyPlayingSong = null;
  try {
    const stored = localStorage.getItem('currentlyPlayingSong');
    if (stored) {
      const parsedSong = JSON.parse(stored);
      // Check if song was saved within the last 24 hours (prevent stale entries)
      const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000);
      if (parsedSong.savedAt && parsedSong.savedAt > twentyFourHoursAgo) {
        currentlyPlayingSong = parsedSong;
        console.log(`🎵 Found currently playing song in localStorage: ${currentlyPlayingSong.trackid}`);
      } else {
        // Clear stale entry
        localStorage.removeItem('currentlyPlayingSong');
        console.log('🗑️ Cleared stale currently playing song from localStorage');
      }
    }
  } catch (e) {
    console.error("Failed to retrieve currently playing song from localStorage:", e);
  }

  // Process tracks (songs are already shuffled at fetch time)
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  let songsForThisVisit = limitedTracks.slice(range.start, range.end);

  // If there's a currently playing song and it's not already in the visible songs, add it at the beginning
  if (currentlyPlayingSong && currentlyPlayingSong.trackid) {
    const isCurrentlyPlayingSongVisible = songsForThisVisit.some(song => song.trackid === currentlyPlayingSong.trackid);
    const isCurrentlyPlayingSongRated = songsRated[currentlyPlayingSong.trackid];

    if (!isCurrentlyPlayingSongVisible && !isCurrentlyPlayingSongRated) {
      // Find the song in the original selection (before visit rotation)
      const originalSong = limitedTracks.find(song => song.trackid === currentlyPlayingSong.trackid);

      if (originalSong) {
        // Add the currently playing song at the beginning of the visible songs
        songsForThisVisit = [originalSong, ...songsForThisVisit];
        console.log(`🎵 Added currently playing song to visible songs: ${currentlyPlayingSong.trackid}`);
      } else {
        // Song might have been filtered out by other filters, try to find it in unrated tracks
        const songInUnrated = unratedTracks.find(song => song.trackid === currentlyPlayingSong.trackid);
        if (songInUnrated) {
          songsForThisVisit = [songInUnrated, ...songsForThisVisit];
          console.log(`🎵 Added currently playing song from unrated tracks: ${currentlyPlayingSong.trackid}`);
        } else {
          // As a last resort, check if it exists in the fetched songs but was filtered by uploader limit
          const songInFetched = uniqueTracks.find(song => song.trackid === currentlyPlayingSong.trackid);
          if (songInFetched) {
            songsForThisVisit = [songInFetched, ...songsForThisVisit];
            console.log(`🎵 Added currently playing song (bypassing uploader limit): ${currentlyPlayingSong.trackid}`);
          }
        }
      }
    } else if (isCurrentlyPlayingSongVisible) {
      console.log(`✅ Currently playing song is already visible: ${currentlyPlayingSong.trackid}`);
    } else if (isCurrentlyPlayingSongRated) {
      console.log(`✅ Currently playing song has been rated: ${currentlyPlayingSong.trackid}`);
    }
  }

  // OPTIMIZED: Always show all available songs to maximize song visibility
  // Previous logic had restrictive slicing that limited songs on certain slides
  // Now we always dispatch all songs for this visit to ensure maximum visibility
  const songsToDispatch = songsForThisVisit;

  // Dispatch the songs if we have any
  if (songsToDispatch && songsToDispatch.length > 0) {
    console.log(`✅ Dispatching ${songsToDispatch.length} songs for slide ${slideNrToShowToUser}, anzahlSongsZufall ${anzahlSongsZufall}`);
    console.log('Song IDs being dispatched:', songsToDispatch.map(s => `${s.trackid} (genre: ${s.genre || 'None'})`));
    dispatch({
      type: "SET_PACKAGEOFSONGSTORATE",
      packageOfSongsTorate: songsToDispatch,
    });
    dispatch({
      type: "SET_DBLESENJANEIN",
      dblesenerlauben: 0,
    });
  }
}, [showSelection, selectionOfTracks, slideNrToShowToUser, anzahlSongsZufall, songsRated, visitCount, dispatch]);

// OLD DISPATCH LOGIC - DEPRECATED
// This code has been moved to the useEffect above to ensure it runs properly
// on mobile devices when state changes. Keeping commented for reference.

/*
// SLIDE 1 - 4 SONGS
if (showSelection===true && slideNrToShowToUser===1 && anzahlSongsZufall===4) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit,
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}

// SLIDE 1 - 5 SONGS
if (showSelection===true && slideNrToShowToUser===1 && anzahlSongsZufall===5) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit,
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}

// SLIDE 2 - 4 SONGS
if (showSelection===true && slideNrToShowToUser===2 && anzahlSongsZufall===4) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit.slice(11,19),
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}

// SLIDE 2 - 5 SONGS
if (showSelection===true && slideNrToShowToUser===2 && anzahlSongsZufall===5) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit,
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}

// SLIDE 3 - 4 SONGS
if (showSelection===true && slideNrToShowToUser===3 && anzahlSongsZufall===4) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit.slice(10,14),
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}

// SLIDE 3 - 5 SONGS
if (showSelection===true && slideNrToShowToUser===3 && anzahlSongsZufall===5) {
  const uniqueTracks = removeDuplicateTrackIds(selectionOfTracks);
  const unratedTracks = filterOutRatedSongs(uniqueTracks, songsRated);
  const limitedTracks = limitSongsPerSpotifyUser(unratedTracks);
  const range = getSongRange(visitCount, limitedTracks.length);
  const songsForThisVisit = limitedTracks.slice(range.start, range.end);

  dispatch({
   type: "SET_PACKAGEOFSONGSTORATE",
   packageOfSongsTorate: songsForThisVisit,
  });

  dispatch({
    type: "SET_DBLESENJANEIN",
    dblesenerlauben:0,
  })
}
*/

// if (dbRequestDone==0) {


//     export const getMetaOutsider = () => {
//         return (dispatch) => {
//           Axios.get("meta/outsiders")
//           .then(res => {
//             dispatch({ type: GET_OUTSIDER_META_INFORMATION, payload: res.data });
//           })
//           .catch(err =>
//             dispatch({ type: POPULATE_ERRORS, payload: err.response.data })
//           );
//         }
//       };



// dispatch({
// type: "SET_SELECTIONOFTRACKS",
// selectionOfTracksFetched: [selectionOfTracks][0],
// });

// setdbRequestDone(1);

// }

    return (
        <div>
            
        </div>
    )
}

export default FBGetSongsFromDB
